(function () {
  const MODAL_SELECTOR = '[data-challenge-day-menu-modal]';

  const setActiveView = (modal, nextView) => {
    if (!modal) return;

    const view = nextView === 'ingredients' ? 'ingredients' : 'recipe';
    modal.dataset.activeView = view;

    modal.querySelectorAll('[data-modal-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.modalPanel !== view;
    });
  };

  const resetModal = (modal) => {
    if (!modal) return;

    setActiveView(modal, modal.dataset.defaultView || 'recipe');

    const slider = modal.querySelector('slider-component');
    if (slider && typeof slider.setSlidePosition === 'function') {
      slider.setSlidePosition(0);
      if (typeof slider.update === 'function') slider.update();
    }
  };

  const initModal = (modal) => {
    if (!modal || modal.dataset.initialized === 'true') return;

    modal.dataset.initialized = 'true';

    modal.querySelectorAll('[data-modal-view-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        setActiveView(modal, trigger.dataset.modalViewTrigger);
      });
    });

    setActiveView(modal, modal.dataset.defaultView || 'recipe');
  };

  const initAll = (container = document) => {
    container.querySelectorAll(MODAL_SELECTOR).forEach(initModal);

    container.querySelectorAll('[data-challenge-day-menu-open]').forEach((trigger) => {
      if (trigger.dataset.initialized === 'true') return;

      trigger.dataset.initialized = 'true';
      trigger.addEventListener('click', () => {
        const modal = document.querySelector(trigger.dataset.challengeDayMenuOpen);

        if (!modal) return;

        requestAnimationFrame(() => {
          const modalContent = modal.querySelector(MODAL_SELECTOR);
          resetModal(modalContent);
        });
      });
    });
  };

  if (window.ChallengeDayMenuModal) {
    window.ChallengeDayMenuModal.initAll();
    return;
  }

  window.ChallengeDayMenuModal = {
    initAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.body.addEventListener('modalClosed', () => {
    document.querySelectorAll(MODAL_SELECTOR).forEach(resetModal);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
